import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_CSR_SUMMARY_REQUEST',
  'GET_CSR_SUMMARY_SUCCESS',
  'GET_CSR_SUMMARY_ERROR'
);
